(() => {
  document.addEventListener('click', (event) => {
    const play = event.target.closest('.rb-remove .video-play');
    if (!play) return;
    const videoId = play.dataset.videoId;
    if (!videoId || !/^[A-Za-z0-9_-]{11}$/.test(videoId)) return;
    const frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0&playsinline=1';
    frame.title = 'REMOVE 特殊水垢取り剤 公式施工動画';
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.allowFullscreen = true;
    play.closest('.video').replaceChildren(frame);
  });
})();
